module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/ma-gallery/ma-gallery-09-ad31fcf15d9b31d2a20a4cb2b5cac6ec.jpg";